import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { selectAccountId } from '@selectors'
import { Link, useParams, useLocation } from 'react-router-dom'
import { SET_ENGAGEMENT_DETAIL_ID } from '@actions/types'

import useStyles, { mapContainerStyle } from './engagement-suggestion-detail.style'

import Breadcrumb from '@components/breadcrumb/breadcrumb.component'
import ResponsiveContainer from '@components/responsive-container/responsive-container.component'
import EngagementDetailHeader from '@components/engagement-detail-header/engagement-detail-header.component'
import Map from '@components/map/map.component'
import i18n from 'i18n-js'
import { USER, USERS } from '../../assets/i18n/strings'

const EngagementSuggestionDetail = (props) => {
  const classes = useStyles(props)

  const { engagementId, replyGuid } = useParams()

  const dispatch = useDispatch()

  const location = useLocation()

  const accountId = useSelector(selectAccountId)

  const engageRef = `engage/${accountId}/cta`

  const engagements = useSelector(
    ({ firestore: { ordered } }) => ordered[engageRef] && ordered[engageRef]
  )

  const engagement = engagements?.find(e => e.id === engagementId)

  useEffect(() => {
    if (engagement) {
      dispatch({ type: SET_ENGAGEMENT_DETAIL_ID, payload: engagementId })
    }
  }, [dispatch, engagement, engagementId])


  if (!engagement) return null

  const { suggestions, no_sent: noSent } = engagement

  const selectedReply = suggestions.find(suggestion => suggestion.reply_guid === replyGuid)

  const { users = [], no_responses: numResponses = 0, text, type } = selectedReply

  const locations = users.map(user => {
    const location = user.location

    if (!location) return null

    const coords = Object.keys(user.location).map(key => user.location[key])
    const [lat, lng] = coords
    return {
      lat,
      lng,
      color: '0000FF'
    }
  }).filter(element => element !== null) || []

  const noNoResponse = () => {
    let totalResponses = 0

    suggestions.forEach(suggestion => {
      const { no_responses: noResponses } = suggestion

      if (noResponses) totalResponses = totalResponses + noResponses
    })

    return noSent - totalResponses
  }

  const usersMessaged = () => {
    if (type === 'no-response') {
      return `${noNoResponse()} ${noNoResponse() === 1 ? i18n.t(USER) : i18n.t(USERS)}`
    }

    return `${numResponses} ${numResponses === 1 ? i18n.t(USER) : i18n.t(USERS)}`
  }

  const center = {
    lat: -31.56391,
    lng: 147.154312
  }

  return (
    <div className={classes.container}>
      <Breadcrumb />
      <ResponsiveContainer className={classes.responsive}>
        <div className={classes.header}>
          <EngagementDetailHeader
            parentTitle={engagement.message_text}
            title={type === 'no-response' ? 'Non-responders' : text}
            usersMessaged={usersMessaged()}
          />
        </div>
        {locations.length > 0 &&
          <Map
            center={center}
            locations={locations}
            mapContainerStyle={mapContainerStyle}
          />}
        <div className={classes.button}>
          <Link
            className='button is-primary'
            to={`${location.pathname}/send`}
          >
            Send Follow-Up
          </Link>
        </div>

      </ResponsiveContainer>
    </div>
  )
}

export default EngagementSuggestionDetail
